import * as React from "react";
const SvgCheckmarkCircle24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M7.556 2.685a9 9 0 1 1 6.888 16.63 9 9 0 0 1-6.888-16.63ZM11 0a11 11 0 1 0 0 22 11 11 0 0 0 0-22ZM9 16.414l8.207-8.207-1.414-1.414L9 13.586l-2.793-2.793-1.414 1.414L9 16.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgCheckmarkCircle24Px;
